
import { defineComponent } from 'vue';
import VInputDatetimeLocal from '@/components/vendor/basic/form/parts/VInputDatetimeLocal.vue';

export default defineComponent({
  name: 'VFormGroupInputDatetime',
  components: {
    VInputDatetimeLocal,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    inputClass: {
      type: String,
      required: false,
      default: '',
    },
    yupErrorsVariable: {
      type: String,
      required: false,
      default: null,
    },
    mask: {
      type: Object,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {
    emitValue(value) {
      this.$emit('update:value', value);
    },
  },
});
